import { cloneDeep } from 'lodash';
import React from 'react';
import { roundOff } from '../../../Components/helper';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { usePlanningBottomupState } from '../Context/index';
import useTotalCalculationHooks from '../Hooks/TotalCalculationHooks';

export function SizeRatio() {
  const { planningBottomup, setPlanningBottomup, checkVisibleBottomUp } = usePlanningBottomupState();
  const { calCulateTotal, calculatedChannelCostArray, calculatedChannelUnitArray } = useTotalCalculationHooks();
  const { planningBottomProducts, currLevel } = planningBottomup;
  const level = planningBottomup?.selectedLevel?.level || 0;
  const sizeRatioField = [
    {
      keyName: 'sizeRatio',
      name: 'Size Ratio',
    },
  ];

  const getRos = (total, sizeRatio) => {
    return roundOff(Number(total) * Number(sizeRatio), 2);
  };

  const modifiedArray = async (copyState, index) => {
    const { basicInfo, _id } = copyState[index];
    const { colour } = basicInfo;
    let total = 0;
    if (copyState[index].totalFpRos > 0) {
      total = copyState[index].totalFpRos;
    } else {
      const filtered = copyState?.filter((data) => data._id === _id && data?.basicInfo?.colour?._id === colour?._id);
      filtered?.forEach((element) => {
        total += Number(element?.fpRos?.value);
      });
    }
    copyState = await calculatedChannelCostArray(copyState, index, level);
    copyState = await calculatedChannelUnitArray(copyState, index, level);

    copyState = copyState.map((eleData) => {
      if (eleData._id === _id && eleData?.basicInfo?.colour?._id === colour?._id) {
        eleData.fpRos.value = getRos(total, eleData?.sizeRatio?.value);
      }
      return eleData;
    });
    return copyState;
  };
  const handleChange = async (e, idx) => {
    const changedData = cloneDeep(planningBottomProducts);
    const { basicInfo, _id } = changedData[idx];
    const { colour } = basicInfo;
    changedData[idx].sizeRatio.value = e;
    if (changedData[idx].totalFpRos > 0) {
      changedData[idx].fpRos.value = Number(e) * Number(changedData[idx].totalFpRos);
    }
    const filtered = changedData.filter((data) => data._id === _id && data?.basicInfo?.colour?._id === colour?._id);
    let total = 0;
    filtered?.forEach((element) => {
      total += Number(element?.sizeRatio?.value);
    });
    if (total > 1) {
      toasterMsg('size ratio is not more than 1', 'danger');
    } else {
      setPlanningBottomup((prev) => ({
        ...prev,
        planningBottomProducts: changedData,
      }));
    }
  };
  const onBlurDataChange = async (idx) => {
    const data = await modifiedArray(planningBottomProducts, idx);
    const calculated = await calCulateTotal(data);
    setPlanningBottomup((prev) => ({
      ...prev,
      planningBottomProducts: calculated,
    }));
  };

  return (
    checkVisibleBottomUp('sizeRatio') && (
      <table className="table custom-table layout-fixed planning-actual-tbl font-13 mr-3">
        <thead>
          <tr>
            {sizeRatioField.map((sizeRatioItem, i) => {
              return (
                <th key={i} className="w-200px">
                  <span>{sizeRatioItem.name}</span>
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {planningBottomProducts?.map((product, idx) => {
            return (
              <tr key={idx}>
                <td>
                  {currLevel === 6 ? (
                    product?.sizeRatio?.value
                  ) : (
                    <input
                      onBlur={() => onBlurDataChange(idx)}
                      className="form-control"
                      onChange={(e) => handleChange(e.target.value, idx)}
                      value={product?.sizeRatio?.value}
                      disabled={level !== 7 || !planningBottomup?.addEditBottomAccess}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    )
  );
}
export default SizeRatio;
